module.exports = __webpack_public_path__ + "static/img/5.8c08e5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/5.png
// module id = UX2t
// module chunks = 0